import React from "react";

import { CoilProvider } from "@alxshelepenok/diesel";
import { WrapRootElementBrowserArgs } from "gatsby";
import ThemeWorldspace from "../../src/components/ThemeWorldspace/ThemeWorldspace";

const wrapRootElement = ({
  element,
}: WrapRootElementBrowserArgs): React.ReactElement => (
  <CoilProvider>
    <ThemeWorldspace />
    {element}
  </CoilProvider>
);

export { wrapRootElement };
